<template>
    <el-tree
        ref="treeRef"
        :data="treeData"
        show-checkbox
        node-key="id"
        :props="treeProps"
        :default-expanded-keys="defaultExpandedKeys"
        :expand-on-click-node="false"
        @check="handleMyMapCheck"
         >
        <template #default="{ data }">
            <span class="custom-tree-node">
            <span>{{ data.name }}</span>
            </span>
        </template>
    </el-tree>
</template>

<script setup>
import { ref, computed, onMounted, reactive } from 'vue';
import { dayjs, message } from '@/utils/js/initVariable';
import { queryFavorites } from '@/api/MyMap';
import store from '@/store'
const props = defineProps({

});
onMounted(()=>{
  getTreeData();
})
const treeRef = ref(null);
const defaultExpandedKeys = ref([]);
const treeData = ref([]);
const treeProps = reactive({
  children: 'children',
  label: 'label'
});

const getTreeData = async () => {
    try {
        const res =  await queryFavorites({});
        if(res.data.code == 1004){
          message(res.data.msg, 1);
          treeData.value = res.data.dataList;
          // console.log("queryFavorites",treeData)
        }} catch (err) {
            console.error('获取我的收藏列表失败:', err);
        }
};

  
  // 处理节点勾选事件
  const currentNode = ref(null);
  const emit = defineEmits(['myMap-selected','myMap-unselected']);
  const handleMyMapCheck = (node, checkedStatus) => {
    if (checkedStatus.checkedKeys.includes(node.id)) {
      treeRef.value.setCheckedKeys([node.id]);
      currentNode.value = node;
      console.log('选中收藏的name & id:', node.name,node.id);
      emit('myMap-selected', {
      name: node.name,
      layerId: node.id
    },
    store.commit('setSelectedMap', node),
   );
    } else {
      console.log('触发mymap取消选中事件:', node.id);
      store.commit('removeSelectedMap', node),
      emit('myMap-unselected', {
      layerId: node.id
    });
    }
  }

</script>

<style scoped>


</style>